<template>
  <div id="app">
    <OwnNumberForm></OwnNumberForm>
  </div>
</template>

<script>
import OwnNumberForm from "./components/OwnNumberForm.vue";
export default {
  name: "App",
  components: {
    OwnNumberForm,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
